




































import { Component, PropSync, Vue } from "vue-property-decorator";
import { readAccessToken } from "../../store/gitlab/getters";
import { dispatchSetAccessToken } from "../../store/gitlab/actions";

@Component
export default class SetAccessToken extends Vue {
  @PropSync("accessTokenSwitch", { type: Boolean })
  private accessTokenSet!: boolean;
  private accessToken = readAccessToken(this.$store);
  private dialog = true;

  private save() {
    dispatchSetAccessToken(this.$store, this.accessToken);
    this.dialog = false;
    this.accessTokenSet = true;
  }
}
